//imports
import {
    UNITTYPES_CREATE_EDIT_OPEN_MODAL,
    UNITTYPES_CREATE_REQUEST,
    UNITTYPES_CREATE_RESULT,
    UNITTYPES_UPDATE_REQUEST,
    UNITTYPES_UPDATE_RESULT,
    UNITTYPES_GET_REQUEST,
    UNITTYPES_GET_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    unittype: null,
    current: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UNITTYPES_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: true, current: action.payload }

        case UNITTYPES_CREATE_REQUEST:
            return { ...state, loading: true }

        case UNITTYPES_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case UNITTYPES_UPDATE_REQUEST:
            return { ...state, loading: true }

        case UNITTYPES_UPDATE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case UNITTYPES_GET_REQUEST:
            return { ...state, loading: true }

        case UNITTYPES_GET_RESULT:
            return { ...state, loading: false, unittype: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_EDIT_UNITTYPES"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
